<template>
  <nav>
    <v-row
      class="fill-height loginBackground"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-alert
          v-if="verificationMsg != '' && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(verificationMsg) }}
        </v-alert>
        <v-alert
          v-if="verificationMsgToken != '' && tokeninvalid == true && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(verificationMsgToken) }}
        </v-alert>
        <v-alert
          v-if="verificationMsgToken != '' && tokeninvalid == false && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(verificationMsgToken) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'success' && verifiedfogotenpass == true && !showAlertInsideForm"
          type="success"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(alertMsg) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'error' && verifiedfogotenpass == false && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(alertMsg) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'error' && samlServerError && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(samlError) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'error' && samlUserDeleted && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(samlError) }}
        </v-alert>
        <v-alert
          v-if="alertType == 'error' && samlEmailTaken && !showAlertInsideForm"
          type="error"
          class="rounded-xxl mb-8 text-left"
          max-width="600"
        >
          {{ $t(samlError) }}
        </v-alert>
        <v-card
          max-width="600"
          elevation="0"
          rounded="xxl"
          color="background"
        >
          <LanguageSwitcher @languageSelected = "updateLocale"/>
          <div
            class="d-inline-block pt-6"
          >
            <v-img
              v-if="logo == null"
              data-testid="logo-space"
              src="../../assets/rtplogo.svg"
              max-width="200"
              contain
              :class="logo != null ? '' : 'default'"
            />
            <v-img
              v-else
              data-testid="logo-space"
              :src="logo"
              width="200"
              class="mx-auto"
              contain
              :aspect-ratio="4/3"
              :class="logo != null ? '' : 'default'"
            />
          </div>
          <v-card-title class="text-h5 font-weight-bold text-center justify-center px-6 no-break">
            {{ $t('loginTitle') }}
          </v-card-title>
          <div class="py-4" v-if="showGoogleLogin || showAtLeastOneIdp">
            <div
              v-for="idp in idps"
              :key="idp.name"
            >
              <v-card-actions
                v-if="idp.enabled && idp.configured_properly"
                class="px-6 py-2"
              >
                <v-btn
                  data-testid="saml-submit-button"
                  type="submit"
                  large
                  block
                  class="rounded-xxl text-none greytext--text"
                  @click="samlLoginUser(idp.name)"
                ><v-icon class="mr-2" color="greytext">mdi-cloud-outline</v-icon>
                  {{ idp.button_text }}
                </v-btn>
              </v-card-actions>
            </div>
            <v-card-actions class="px-6 py-2" v-if="showGoogleLogin">
              <GoogleButton data-testid="google-button"/>
            </v-card-actions>
          </div>
          <v-row align="center" no-gutters class="ma-8" v-if="showGoogleLogin || showAtLeastOneIdp">              
            <v-divider class="text-divider"></v-divider><span class="px-3 greytext--text">{{ $t('or')}}</span><v-divider class="text-divider"></v-divider>
          </v-row>
          <v-card-subtitle class="text-body-2 pt-4 px-6 no-break">
            {{ $t('loginSubTitle') }}
          </v-card-subtitle>
          <v-card-text class="px-6">
            <v-alert
              v-if="alertType == 'error' && verified == true && verifiedfogotenpass == true && showAlertInsideForm"
              type="error"
              class="rounded-xxl text-left"
            >
              {{ $t(alertMsg) }}
            </v-alert>
            <v-alert
              v-if="alertType == 'error' && verified == false && showAlertInsideForm"
              type="error"
              class="rounded-xxl text-left"
            >
              {{ $t(alertMsg) }}
              <router-link
                data-testid="resend-link"
                to="#"
                class="white--text"
                @click.native="resendConfirmationLink"
              >
                {{ $t('resendVerificationLink') }}
              </router-link>
              <v-progress-circular
                v-if="isLoading"
                size="20"
                indeterminate
                class="mx-2"
              />
            </v-alert>
            <v-alert
              v-if="alertType == 'success' && verified == false && showAlertInsideForm"
              type="success"
              class="rounded-xxl text-left"
            >
              {{ $t(alertMsg) }}
            </v-alert>
            <v-form
              ref="form"
              v-model="valid"
              @keyup.enter="login"
              @submit.prevent
            >
              <v-text-field
                v-model="email"
                data-testid="email-input"
                solo
                hide-details="auto"
                elevation="6"
                class="rounded-xxl text-body-2"
                :placeholder="$t('loginEmailPlaceholder')"
                :rules="emailRules"
                @keyup.enter="focusNext($event.target)"
              />
              <v-text-field
                v-model="password"
                data-testid="password-input"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('loginPasswordPlaceholder')"
                :rules="passwordRules"
                @keyup.enter="focusNext($event.target)"
                @click:append="showPassword = !showPassword"
              />
              <v-card-actions class="px-0">
                <v-btn
                  data-testid="submit-button"
                  type="submit"
                  :disabled="buttonDisabled"
                  color="accent"
                  large
                  block
                  class="rounded-xxl text-none"
                  @click="login"
                >
                  {{ $t('signIn') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
                    
          <v-card-actions class="pa-6">
            <v-spacer />
            <v-btn
              data-testid="forgotten-pass-dialog-button"
              class="forgottenpass text-decoration-none text-none text-body-2 darktext--text"
              elevation="0"
              @click.stop="
                dialogVisible=true, 
                forgottenPassDialogEmail = '',
                forgottenPassDialogTitle=$t('forgottenPassDialogTitle'), 
                forgottenPassDialogText=$t('forgottenPassDialogText'),
                forgottenPassDialogSubmitBtn=$t('send')
                forgottenPassDialogCancelBtn=$t('back')"
            >
              {{ $t('loginResetPasswordLink') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <ForgottenPassDialog
      :visible="dialogVisible" 
      :email-fogotten-pass="forgottenPassDialogEmail" 
      :cd-title="forgottenPassDialogTitle" 
      :cd-text="forgottenPassDialogText"
      :cd-submit-btn="forgottenPassDialogSubmitBtn" 
      :cd-cancel-btn="forgottenPassDialogCancelBtn" 
      @close="dialogVisible=false" 
      @proceedSend="proceedSend"
    />
  </nav>
</template>
<script>
import { ruleRequired } from '../../rules/formRules.js'
import i18n from '../../plugins/i18n'
import { loginAuth } from '../../auth/auth.js'
import { loginUser, resendEmail, samlLoginUser } from '../../api/userApi'
import { getSpaceByURL } from '../../api/spaceApi'
import ForgottenPassDialog from '../../components/ForgottenPassDialog'
import LanguageSwitcher from '../../components/LanguageSwitcher'
import GoogleButton from '../../components/GoogleButton'

export default {
    components: {
        ForgottenPassDialog,
        LanguageSwitcher,
        GoogleButton
    },
    data(){
        return{
            valid: true,
            email: '',
            password: '',
            showPassword: false,
            alertType: '',
            alertMsg: '',
            showAlertInsideForm: false,
            buttonDisabled: false,
            showVerificationMsg: false,
            verificationMsg: '',
            verificationMsgToken :'',
            token: '',
            verified: true,
            verifiedfogotenpass: true,
            isLoading: false,
            dialogVisible: false,
            forgottenPassDialogTitle: '',
            forgottenPassDialogText: '',
            forgottenPassDialogCancelBtn: '',
            forgottenPassDialogSubmitBtn: '',
            forgottenPassDialogEmail:'',
            tokeninvalid: true,
            space: window.location.host.split('.')[0],
            role: localStorage.space ? JSON.parse(localStorage.space).role : null,
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
            spaceSubdomain: localStorage.space ? JSON.parse(localStorage.space).subdomain : null,
            samlServerError: false,
            samlUserDeleted: false,
            samlEmailTaken: false,
            focusNext(elem) {
                const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                elem.form.elements.item(
                    currentIndex < elem.form.elements.length - 1 ?
                    currentIndex + 1 :
                    0
                ).focus();
            },
            googleCallback: false,
            showGoogleLogin: localStorage.space? JSON.parse(localStorage.space).show_google_login: false,
            languageRuleActive: true,
            showAtLeastOneIdp: false
         }
    },
    computed: {
        emailRules() {
            return this.languageRuleActive ? ruleRequired('labelEmail') : []
        },
        passwordRules() {
            return this.languageRuleActive ? ruleRequired('labelPassword') : []
        }
    },
    created() {
        if(this.$route.params.verifiedEmail){
            this.verificationMsg = 'confirmAccountSucess'
        }
        if(this.$route.params.alreadyVerifiedEmail){
            this.verificationMsg = 'confirmAccountErrorAlreadyVerified'
        }
        if(this.$route.params.passwordReset ==  true){
            this.tokeninvalid = true
            this.verificationMsgToken  = 'updatedNewPassword'
        }else if(this.$route.params.passwordReset == false){
            this.tokeninvalid = false
            this.verificationMsgToken  = 'serverError'
        }
        if(this.$route.params.samlServerError){
            this.alertType = 'error'
            this.samlServerError = true
            this.samlError  = 'samlServerError'
        }
        if(this.$route.params.samlUserDeleted){
            this.alertType = 'error'
            this.samlUserDeleted = true
            this.samlError  = 'samlUserDeleted'
        }
        if(this.$route.params.samlEmailTaken){
            this.alertType = 'error'
            this.samlEmailTaken = true
            this.samlError  = 'samlEmailTaken'
        }

        if (this.idps && this.idps.length > 0) {
          this.idps.forEach(idp => {
            if (idp.enabled && idp.configured_properly){
                this.showAtLeastOneIdp = true
                if(idp.direct_redirect){
                   this.samlLoginUser(idp.name)
                }
              }
          })
        }

        //show error message for SSO when use Google
        if(window.$cookies.isKey("show_sso_error")){
            this.alertType = 'error'
            this.alertMsg = 'mustLogInUsingSSO'
            this.showAlertInsideForm = true
            window.$cookies.remove("show_sso_error")
            window.$cookies.remove("show_sso_error", null, process.env.VUE_APP_DOMAIN);
        }
    },
    methods: {
        proceedSend(msg, type){
            if(type == 'success'){
                this.isLoading = true
                this.verifiedfogotenpass = true
                this.dialogVisible = false
                this.alertType= type
                this.alertMsg = msg
            }
            if(type == 'error'){
                this.isLoading = true
                this.verifiedfogotenpass = false
                this.dialogVisible = false
                this.alertType= type
                this.alertMsg = msg
            }
            this.showAlertInsideForm = false
            this.isLoading = false
        },

        async login(){
            function checkCookie(name) {
                var dc = document.cookie;
                var prefix = name + "=";
                var begin = dc.indexOf("; " + prefix);
                if (begin == -1) {
                    begin = dc.indexOf(prefix);
                    if (begin != 0) return null;
                }
            }

            checkCookie('id') && window.$cookies.remove("id", null, process.env.VUE_APP_DOMAIN)
            checkCookie('token') && window.$cookies.remove("token", null, process.env.VUE_APP_DOMAIN)
            localStorage.clear()

            this.verified = true
            this.$refs.form.validate()
            if(this.valid){
                this.buttonDisabled = true
                try {
                    let data = {
                        email: this.email.trim(),
                        password: this.password.trim()
                    };
                    const response = await loginUser(data)
                    if(response.status == 200) {
                        loginAuth(response.data.meta.access_token, response.data.data)
                        
                        i18n.locale = response.data.data.attributes.language && response.data.data.attributes.language.trim()
                        window.$cookies.set("language", i18n.locale, 0, null, process.env.VUE_APP_DOMAIN)

                        if(this.$route.params.signature){
                            this.$router.push({name: 'JoinSpace', params: {signature: this.$route.params.signature}})
                        } else {
                            try {
                                const response_space = await getSpaceByURL(this.space)                                
                                if(response_space.status){
                                    if(response_space.status == 200) {
                                        localStorage.space = JSON.stringify(response_space.data.data.attributes)                           
                                        const role = response_space.data.data.attributes.role
                                        this.$store.dispatch("getSubscribedPlan", response_space.data.data).catch(error => {
                                          if (error.response.status == 403) {
                                            this.$router.push({name: 'PageAccessDenied'})
                                          }
                                          if (error.response.status == 404) {
                                            this.$router.push({name: 'PageNotFound'})
                                          }
                                        })
                                        this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
                                        if (this.$route.query.referer) {
                                            const space = window.location.host.split('.')[0];
                                            window.location.href = process.env.VUE_APP_PROTOCOL + "://" + space + "." + process.env.VUE_APP_DOMAIN + this.$route.query.referer
                                        } else {                                       
                                            if(role == 'participant' || role == 'guest'){
                                                this.$router.push(this.$route.query.redirect || '/dashboard-participant')
                                            } else {
                                                this.$router.push(this.$route.query.redirect || '/')
                                            }
                                        }
                                    }
                                }
                            } catch (e) {
                                if(e.response){
                                    if(e.response.status == 403){
                                        this.$router.push('/forbidden')
                                    }
                                }
                            }
                        }
                    }
                    this.$refs.form.reset()
                } catch (e) {
                    this.alertType = 'error'
                    if(e.response){
                        if(e.response.status == 401){
                            this.alertMsg = 'loginErrorWrongCredentials'
                        } else if(e.response.status == 403){
                            for (let i = 0; i < e.response.data.errors.length; i++) {
                                if (e.response.data.errors[i].detail == 'You must log in using SSO') {
                                    this.alertType = 'error'
                                    this.alertMsg = 'mustLogInUsingSSO'
                                } else {
                                    this.alertMsg = 'loginErrorEmailNotVerified'
                                    this.verified = false
                                    this.token = e.response.data.errors[0].meta.access_token;
                                }
                            }
                        } else {
                            this.alertMsg =  'serverError'
                        }
                        this.showAlertInsideForm = true
                    }
                }
                this.buttonDisabled = false
            }
        },
        async samlLoginUser(idpName){
          try {
            let redirect = ''
            if (this.spaceSubdomain) {
              redirect = process.env.VUE_APP_PROTOCOL + "://" + this.spaceSubdomain + "." + process.env.VUE_APP_DOMAIN + "/saml-login"
            }

            let referer = ''
            if (this.$route.query.referer) {
              referer = this.spaceSubdomain + "." + process.env.VUE_APP_DOMAIN + this.$route.query.referer
            } else if (this.$route.query.redirect && this.$route.query.redirect != '/') {
              referer = this.spaceSubdomain + "." + process.env.VUE_APP_DOMAIN + this.$route.query.redirect
            }

            const response = await samlLoginUser(idpName, redirect, referer)
            if (response.status == 200) {
                window.open(response.data.url, "_self");
            }
          } catch (e) {
          if(e.response){
            if(e.response.status == 403){
                this.$router.push('/forbidden')
              }
            }
          }
        },
        async resendConfirmationLink(){
            this.isLoading = true
            try {
                const response = await resendEmail(this.token)
                if(response.status == 200) {
                    this.verified = false
                    this.alertType = 'success'
                    this.alertMsg =  'verificationLinkSent'
                    this.isLoading = false
                }
            } catch (e){
                this.alertType = 'error'
                this.alertMsg =  'serverError'
                this.isLoading = false
            }

            this.showAlertInsideForm = true
        },
        updateLocale() {
            this.languageRuleActive = false
            this.$nextTick(() => {
              this.languageRuleActive = true
            })
        },
    },
}
</script>
<style>
.forgottenpass.v-btn--contained,
.forgottenpass.v-btn--contained:active{
    box-shadow: none;
}
.forgottenpass.v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before,
.forgottenpass.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before{
    opacity: 0;
}
</style>